// extracted by mini-css-extract-plugin
export default {"wrapper":"MainTableToolbar_wrapper__j-Dy4"};